import { AppState } from 'app/store';

export const getAlerts = (state: AppState) => state.alerts.queue;
